import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    moduleManageContainer: {
        width: '83%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '5px'
    },
    activeModule: {
        display: 'flex',
        paddingLeft: '5px',
        alignItems: 'center',
        marginBottom: '25px'
    },
    text: {
        fontWeight: '25px',
        marginRight: '15px',
        marginLeft: '15px'
    },
    configContainer: {
        paddingLeft: '15px',
    },
    draggableSite: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px'
    },
    siteName: {
        color: '#4d4b4b',
        width: '220px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginLeft: '10px',
        marginRight: '5px'
    },
    configIcon: {
        marginLeft: '5px'
    },
    moduleSiteSelect: {
        width: '75%'
    },
    form: {
        display: 'flex',
        marginBottom: '7px',
        marginLeft: '25px',
        alignItems: 'center'
    },
    formText: {
        width: '90px',
    },
    titleText: {
        fontWeight: 'bold',
        marginRight: '15px',
        marginLeft: '15px',
        fontSize: '15px'
    }
}));
